resourcePaths = '{"rootPath":"","assetsPath":""}';function Footer () {
  this.priority = 2000;
  this.id = null;
  this.node = null;
  this.$node = null;
  this.declaredClass = null;

  this._footNotesLoader = $('.js--footnotes-loader');

  this.init = function () {
    this.$node = $(this.node);
  };

  this.initAllReady = function () {
    this._mobileNavigationToggle();
    this._footNotesLoader.hide();

    var apiPresenter = (window.marketingApiPresenter =
      window.marketingApiPresenter || new APIPresenter());
    var $pageLegal = this.$node.find('.js--marketing-footnotes');
    var $globalLegal = this.$node.find('.js--marketing-disclaimers');
    var currentProvince = $pageLegal.data('legalProvince');

    $pageLegal.mogo().create('LegalDisclaimer', {
      otherLegal: $pageLegal.data('other-legal'),
      legal: $('[data-legal]:visible'),
      itemContainer:
        '<ol class="marketing-footer-container marketing-footer-footnotes__list"></ol>',
      itemClasses: 'marketing-footer-footnotes__list-item',
      presenter: apiPresenter,
      provinceOverride: currentProvince
    });

    $globalLegal.mogo().create('LegalDisclaimer', {
      otherLegal: $globalLegal.data('other-legal') || [
        'disclaimer.mogoCorporateStandard',
        'disclaimer.otherCompanyLogos'
      ],
      itemContainer: '<ul class="marketing-footer-disclaimers__list"></ul>',
      itemClasses: 'marketing-footer-disclaimers__list-item',
      presenter: apiPresenter
    });
  };

  this._mobileNavigationToggle = function () {
    this.$node = $(this.node);

    var activeClass = 'marketing-footer-navigation--active';
    var listClass = 'marketing-footer-navigation__list';
    var headingClass = 'marketing-footer-navigation__list-heading';
    var linkClass = 'marketing-footer-navigation__link';

    var $toggleButton = this.$node.find('.' + headingClass);
    var $toggleTarget = this.$node.find('.' + listClass);
    var $mobileLink = $('.' + linkClass);

    $toggleButton.on('click', function (event) {
      var $currentNav = $(this).closest($toggleTarget);

      if ($currentNav.hasClass(activeClass)) {
        $currentNav.removeClass(activeClass);
      } else {
        $toggleTarget.removeClass(activeClass);
        $currentNav.addClass(activeClass);
      }
    });

    $mobileLink.on('focus', function () {
      var $currentNav = $(this).closest($toggleTarget);
      var $otherNavs = $currentNav.siblings($toggleTarget);

      $currentNav.addClass(activeClass);
      $otherNavs.removeClass(activeClass);
    });
  };
}
